import { AuditReportsAodRuleReportTypeEnum } from '@mi-front/api-v2';

/** Report types that have editable templates in admin. */
export const AUDIT_TEMPLATE_REPORT_TYPES = [
  AuditReportsAodRuleReportTypeEnum.AUDIT_GIP_STATUS,
  AuditReportsAodRuleReportTypeEnum.AUDIT_GIP_ALTERNATIVE_REPORT,
] as const;

export type AuditTemplateReportType = (typeof AUDIT_TEMPLATE_REPORT_TYPES)[number];
